<template>
  <img
    class="carousel__item-image"
    :src="item.src"
    :srcset="item.srcset"
    :alt="item.alt"
  />
</template>

<script>
export default {
  name: 'SanitasCarouselItemImage',

  props: {
    item: {
      type: Object,
      required: true,
      // Props:
      //   src: String
      //   srcset: String
      //   alt: String
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.carousel__item-image {
  width: 100%;
  height: 100%;
}
</style>
